export * from './dist/index.es'



//////////////////
// WEBPACK FOOTER
// ./node_modules/lingui-react/index.es.js
// module id = 6
// module chunks = 2